import { authorize, postRequest } from 'utils/http';
import { AWS_API_URL } from 'global/environment';

export async function submitServiceReportAPI(report) {
  const backendURL = `${AWS_API_URL}/servicedesk-report`;

  return postRequest(backendURL, { data: report }, await authorize());
}
